import {PaymentOptions} from "src/core/payments/constants";
import Swifter from "src/core/payments/swifter/Swifter";
import {BankPaymentSource} from "src/core/payments/models/paymentSource";
import suspensify from "@ui/utils/suspensify";
import {lazy} from "react";

const SwifterPaymentForm = suspensify(
  lazy(() => import("src/core/payments/swifter/SwifterForm"))
);

export default {
  type: PaymentOptions.SWIFTER,
  PaymentClass: Swifter,
  PaymentForm: SwifterPaymentForm,
  PaymentSource: {
    class: BankPaymentSource,
    options: {
      retryLabel: "Retry",
      displayConvenienceFee: true,
    },
  },
};
